<div *nzModalTitle class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
    <div style="display: flex; align-items: center;">
        <p class="modal-title">{{data.nzTitle}}</p>
    </div>
</div>

<div #modalContent class="mx-4">
    @if (isLoading) {
	    <app-loader></app-loader>
	}
	@else{
        <form nz-form [nzLayout]="'vertical'">
            <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="p-4">
                <nz-form-item nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" class="px-4">
                    <nz-form-label [nzRequired]="true">
                        Producto examinado
                    </nz-form-label>
                    <nz-form-control nzErrorTip="Indique el producto examinado">
                        <nz-select nzShowSearch [(ngModel)]="finalProductSelected" [name]="'finalProductSelected'"
                            [ngModelOptions]="{standalone: true}" [nzPlaceHolder]="'Indique el producto examinado'">
                            @for (option of data.finalProducts; track option) {
                            <nz-option
                                [nzLabel]="option.article?.name + (option.articleBatch ? ('-' + option.articleBatch.batchNumber) : '' )"
                                [nzValue]="option.id"></nz-option>
                            }
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
                @for (cf of customFields; track cf.id) {
                @switch (cf.propertiesFormated?.type) {
                @case (typesEnum.INPUT_TEXT) {
                <nz-form-item nz-col [nzXs]="cf.propertiesFormated?.colXs ? cf.propertiesFormated?.colXs! : 24"
                    [nzSm]="cf.propertiesFormated?.colSm ? cf.propertiesFormated?.colSm! : 12"
                    [nzMd]="cf.propertiesFormated?.colMd ? cf.propertiesFormated?.colMd! : 8" class="px-4">
                    <nz-form-label [nzRequired]="cf.restrictionsFormated?.required">
                        {{cf.propertiesFormated?.name}}
                    </nz-form-label>
                    <nz-form-control [nzErrorTip]="'El campo'+ cf.propertiesFormated?.name +'es obligatorio'">
                        <input onfocus="select()" nz-input [(ngModel)]="cf.value" type="text" [style]="
                                (cf.propertiesFormated?.style ?? '')
                                + (cf.propertiesFormated?.height ? 'height:' + cf.propertiesFormated?.height + 'px;' : '')
                                + (cf.propertiesFormated?.width ? 'width:' + cf.propertiesFormated?.width + 'px;' : '')
                            " [class]="cf.propertiesFormated?.cssClass ?? ''" [ngModelOptions]="{standalone: true}"
                            [id]="cf.entity+cf.id" [title]="cf.propertiesFormated?.description"
                            [placeholder]="cf.propertiesFormated?.placeholder ? cf.propertiesFormated?.placeholder : ''" />
                    </nz-form-control>
                </nz-form-item>
                }
                @case (typesEnum.INPUT_NUMBER) {
                <nz-form-item nz-col [nzXs]="cf.propertiesFormated?.colXs ? cf.propertiesFormated?.colXs! : 24"
                    [nzSm]="cf.propertiesFormated?.colSm ? cf.propertiesFormated?.colSm! : 12"
                    [nzMd]="cf.propertiesFormated?.colMd ? cf.propertiesFormated?.colMd! : 8" class="px-4">
                    <nz-form-label [nzRequired]="cf.restrictionsFormated?.required">
                        {{cf.propertiesFormated?.name}}
                    </nz-form-label>
                    <nz-form-control [nzErrorTip]="'El campo'+ cf.propertiesFormated?.name +'es obligatorio'">
                        <input onfocus="select()" nz-input [(ngModel)]="cf.value" type="number" [style]="
                                (cf.propertiesFormated?.style ?? '')
                                + (cf.propertiesFormated?.height ? 'height:' + cf.propertiesFormated?.height + 'px;' : '')
                                + (cf.propertiesFormated?.width ? 'width:' + cf.propertiesFormated?.width + 'px;' : '')
                            " [class]="cf.propertiesFormated?.cssClass ?? ''" [ngModelOptions]="{standalone: true}"
                            [id]="cf.entity+cf.id" [title]="cf.propertiesFormated?.description"
                            [placeholder]="cf.propertiesFormated?.placeholder ? cf.propertiesFormated?.placeholder : ''"
                            [min]="cf.restrictionsFormated?.min ?? null" [max]="cf.restrictionsFormated?.max ?? null" />
                    </nz-form-control>
                </nz-form-item>
                }
                @case (typesEnum.CHECKBOX) {
                <nz-form-item nz-col [nzXs]="cf.propertiesFormated?.colXs ? cf.propertiesFormated?.colXs! : 24"
                    [nzSm]="cf.propertiesFormated?.colSm ? cf.propertiesFormated?.colSm! : 12"
                    [nzMd]="cf.propertiesFormated?.colMd ? cf.propertiesFormated?.colMd! : 8" class="px-4">
                    <nz-form-label [nzRequired]="cf.restrictionsFormated?.required">
                        {{cf.propertiesFormated?.name}}
                    </nz-form-label>
                    <nz-form-control [nzErrorTip]="'El campo'+ cf.propertiesFormated?.name +'es obligatorio'">
                        <nz-switch [(ngModel)]="cf.value" [id]="cf.entity+cf.id"
                            [title]="cf.propertiesFormated?.description ?? ''"
                            [class]="cf.value ? 'switch-on' : 'switch-off'"
                            [ngModelOptions]="{standalone: true}"></nz-switch>&nbsp;
                        <label>{{cf.propertiesFormated?.name}}</label>
                    </nz-form-control>
                </nz-form-item>
                }
                @case (typesEnum.RADIOBUTTONGROUP) {
                <nz-form-item nz-col [nzXs]="cf.propertiesFormated?.colXs ? cf.propertiesFormated?.colXs! : 24"
                    [nzSm]="cf.propertiesFormated?.colSm ? cf.propertiesFormated?.colSm! : 12"
                    [nzMd]="cf.propertiesFormated?.colMd ? cf.propertiesFormated?.colMd! : 8" class="px-4">
                    <nz-form-label [nzRequired]="cf.restrictionsFormated?.required">
                        {{cf.propertiesFormated?.name}}
                    </nz-form-label>
                    <nz-form-control [nzErrorTip]="'El campo'+ cf.propertiesFormated?.name +'es obligatorio'">
                        <nz-radio-group [(ngModel)]="cf.value" [ngModelOptions]="{standalone: true}"
                            [name]="cf.entity+cf.id">
                            @for (option of cf.propertiesFormated?.optionsFormatted; track option) {
                            <label nz-radio [nzValue]="option" [title]="cf.propertiesFormated?.description ?? ''" [style]="
                                            (cf.propertiesFormated?.style ?? '')
                                            + (cf.propertiesFormated?.height ? 'height:' + cf.propertiesFormated?.height + 'px;' : '')
                                            + (cf.propertiesFormated?.width ? 'width:' + cf.propertiesFormated?.width + 'px;' : '')
                                        " [class]="cf.propertiesFormated?.cssClass ?? ''">{{option}}</label>
                            }
                        </nz-radio-group>
                    </nz-form-control>
                </nz-form-item>
                }
                @case (typesEnum.SELECT) {
                <nz-form-item nz-col [nzXs]="cf.propertiesFormated?.colXs ? cf.propertiesFormated?.colXs! : 24"
                    [nzSm]="cf.propertiesFormated?.colSm ? cf.propertiesFormated?.colSm! : 12"
                    [nzMd]="cf.propertiesFormated?.colMd ? cf.propertiesFormated?.colMd! : 8" class="px-4">
                    <nz-form-label [nzRequired]="cf.restrictionsFormated?.required">
                        {{cf.propertiesFormated?.name}}
                    </nz-form-label>
                    <nz-form-control [nzErrorTip]="'El campo'+ cf.propertiesFormated?.name +'es obligatorio'">
                        <nz-select nzShowSearch [(ngModel)]="cf.value" [name]="cf.entity+cf.id" [style]="
                                (cf.propertiesFormated?.style ?? '')
                                + (cf.propertiesFormated?.height ? 'height:' + cf.propertiesFormated?.height + 'px;' : '')
                                + (cf.propertiesFormated?.width ? 'width:' + cf.propertiesFormated?.width + 'px;' : '')
                            " [class]="cf.propertiesFormated?.cssClass ?? ''" [ngModelOptions]="{standalone: true}"
                            [nzPlaceHolder]="cf.propertiesFormated?.placeholder ? cf.propertiesFormated?.placeholder! : ''">
                            @for (option of cf.propertiesFormated?.optionsFormatted; track option) {
                            <nz-option [nzLabel]="option" [nzValue]="option"></nz-option>
                            }
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
                }
                @case (typesEnum.MULTISELECT) {
                <nz-form-item nz-col [nzXs]="cf.propertiesFormated?.colXs ? cf.propertiesFormated?.colXs! : 24"
                    [nzSm]="cf.propertiesFormated?.colSm ? cf.propertiesFormated?.colSm! : 12"
                    [nzMd]="cf.propertiesFormated?.colMd ? cf.propertiesFormated?.colMd! : 8" class="px-4">
                    <nz-form-label [nzRequired]="cf.restrictionsFormated?.required">
                        {{cf.propertiesFormated?.name}}
                    </nz-form-label>
                    <nz-form-control [nzErrorTip]="'El campo'+ cf.propertiesFormated?.name +'es obligatorio'">
                        <nz-select [nzMaxTagCount]="5" [nzMaxTagPlaceholder]="tagPlaceHolder" nzMode="multiple"
                            [nzPlaceHolder]="cf.propertiesFormated?.placeholder ? cf.propertiesFormated?.placeholder! : ''"
                            [(ngModel)]="cf.value" [style]="
                                (cf.propertiesFormated?.style ?? '')
                                + (cf.propertiesFormated?.height ? 'height:' + cf.propertiesFormated?.height + 'px;' : '')
                                + (cf.propertiesFormated?.width ? 'width:' + cf.propertiesFormated?.width + 'px;' : '')
                            " [class]="cf.propertiesFormated?.cssClass ?? ''" [ngModelOptions]="{standalone: true}"
                            [nzMaxMultipleCount]="cf.propertiesFormated?.multiSelectMaxChoices ?? infinity">
                            @for (option of cf.propertiesFormated?.optionsFormatted; track option) {
                            <nz-option [nzLabel]="option" [nzValue]="option"></nz-option>
                            }
                        </nz-select>
                        <ng-template #tagPlaceHolder let-selectedList>y {{ selectedList.length }} más
                            seleccionados</ng-template>
                    </nz-form-control>
                </nz-form-item>
                }
                }
                }
            </div>
        </form>
    }
</div>

<div *nzModalFooter>
    <div class="flex justify-end">
        <button (click)="handleCancel()" class="button secondary-button mr-2">
            Cancelar
        </button>

        <button nz-button class="button primary-button" (click)="submitForm()" [nzLoading]="isSaving">
            Terminar control de calidad
        </button>
    </div>
</div>